import { useAppContexts } from "hooks/use-context";
import { SnapLabeledToggle } from "suit";

function DebitCard() {
  const { program } = useAppContexts();

  return (
    <div className="card">
      <h1 className="text-lg font-semibold mb-4">Enabled Debit Card</h1>
      <SnapLabeledToggle
        label="This will allow for debit cards to be created."
        onSnap-labeled-toggle-click={(e) => {
          program?.setIsDebitCardEnabled(e.detail.checked);
        }}
        checked={program?.isDebitCardEnabled}
      />
    </div>
  );
}

export default DebitCard;
